import { useState, useEffect } from "react";
import { IconButton, makeStyles, Modal } from "@material-ui/core";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { InputField } from "../../../../../components/input-field/InputField";
import { InputButton } from "../../../../../components/input-button/InputButton";
import { BusinessWithdrawTarificationService } from "../../../../../services/BusinessWithdrawTarificationService";
import BusinessWithdrawTafification from "../../../../../models/BusinessWithdrawTafification";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IcipWithdrawTarificationService from "../../../../../services/IcipWithdrawTarificationService";
import IcipWithdrawTafification from "../../../../../models/IcipWithdrawTarification";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CurrencyService from "../../../../../services/CurrencyService";
import { IcipWithdrawTafificationAttributes } from "../../../../../attributes/icip-withdraw-tafification-attributes";
import { Autocomplete } from "@material-ui/lab";

interface EditIcipWithdrawTarificationProps {
  closeCallback: () => void;
  //onRefresh: (data: any) => void;
  onSubmitCallback: () => void;
  isOpened: boolean;
  currencies: any[];
  tarification: IcipWithdrawTafification;
  //handleEditCallBack: (e, data) => void;
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalTitle: {
    fontSize: 25,
    fontWeight: "bold",
  },
  modalBody: {
    width: 700,
    padding: 10,
    border: "none",
  },
  searchAuto:{ 
    //border: '1px outset lightgray',
    
  },

  antPickerDropdown: {
    zIndex: 100000,
  },
}));

export const EditIcipWithdrawTarification = (
  props: EditIcipWithdrawTarificationProps
) => {
  const classes = useStyles();
  const intl = useIntl();
  const { formatMessage } = useIntl();
  const { tarification, closeCallback, isOpened, onSubmitCallback } = props;
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [succeed, setSucceed] = useState(false);
  const [currencies, setcurrencies] = useState(props.currencies);
  const [currentTarification, setCurrentTarification] = useState(
    props.tarification
  );
  const [updatedTarification, setUpdatedTarification] = useState({});
  const [currenciesObjet, setCurrenciesObjet] = useState([]);

  const formik = useFormik({
    initialValues: {
      min_amount: tarification.min_amount,
      max_amount: tarification.max_amount,
      commission_percentage: tarification.commission_percentage,
      fees: tarification.fees,
      currency_id: tarification.currency.id,
    },
    validationSchema: Yup.object().shape({
      min_amount: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterMinAmount" })
      ),
      max_amount: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterMaxAmount" })
      ),
      commission_percentage: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCommissionPercentage" })
      ),
      fees: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterFixedFees" })
      ),
      currency_id: Yup.number().required(
        formatMessage({ id: "sharedScreen.pleaseEnterCurrency" })
      ),
    }),
    onSubmit: async (
      values,
      { setSubmitting, resetForm }: FormikHelpers<any>
    ) => {
      setError(false);
      console.log(values);
      try {
        const updateTarificationResult = await IcipWithdrawTarificationService.updateIcipWithdrawTarification(
          currentTarification.id,
          currentTarification
        );
        if (
          updateTarificationResult.isSuccess &&
          updateTarificationResult.data.code === 100
        ) {
          resetForm({});
          setSucceed(true);
          setTimeout(() => {
            setSucceed(false);
          }, 2000);
          setUpdatedTarification(updateTarificationResult);
          onSubmitCallback();
        } else {
          setError(true);
          if (updateTarificationResult.data.code === 101) {
            setErrorMessage("Min amount must be lower than max amount");
          } else {
            if (updateTarificationResult.data.code === 102) {
              setErrorMessage("Similar tarification already exist");
            } else {
              if (updateTarificationResult.data.code === 103) {
                setErrorMessage(
                  "There is overlap with another tarification withdraw"
                );
              } else {
                setErrorMessage("");
              }
            }
          }
        }
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  const handleDataChange = (name: string, value: string) => {
    let currTarification = { ...currentTarification };
    currTarification[name] = value;

    setCurrentTarification(currTarification);
  }

  
  const loadCurrenciesList = () => {
    CurrencyService.supportedCurrencies().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const currenciesResults = JSON.parse(
              JSON.stringify(response.data.data)
            );
            setCurrenciesObjet(currenciesResults);
            break;
          case 110:
            setError(true);
            break;
        }
      } else {
        setError(true);
      }
    });
  };

  useEffect(() => {
    loadCurrenciesList();
    setCurrentTarification(props.tarification);
  }, [tarification]);
  
  
  const handleClose = (e) => {
    closeCallback();
  }
  return (
    <>
      <Paper className={classes.modalBody}>
          <form noValidate onSubmit={formik.handleSubmit} autoComplete="off" method={"post"}>
            <Grid container spacing={2}>
            <Grid
                item
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                xs={12}
                sm={12}
                lg={12}
              >
                <Typography
                  className={classes.modalTitle}
                  variant="h4"
                  component="h4"
                >
                  <FormattedMessage id="sharedScreen.editIcipWithdrawTarificationTitle" />
                </Typography>
                <IconButton edge="end" onClick={(e) =>handleClose(e)}>
                  <HighlightOffIcon fontSize="large" />
                </IconButton>
              </Grid>
              <Grid
                item
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                xs={12}
                sm={12}
                lg={12}
              >
              </Grid>
              {error && (
                <Grid item xs={12} sm={12} lg={12}>
                  <Alert severity="error">
                    {errorMessage === "" && (
                      <FormattedMessage id="sharedScreen.thereWasAProblemEditIcipWithdrawTarif" />
                    )}
                    {errorMessage !== "" && <p>{errorMessage}</p>}
                  </Alert>
                </Grid>
              )}
              <Grid item xs={12} sm={12} lg={12}>
                <InputField
                  //value={formik.values.min_amount}
                  value={currentTarification.min_amount}
                  type="number"
                  fullWidth
                  label={formatMessage({ id: "sharedScreen.minAmount" })}
                  placeholder={formatMessage({ id: "sharedScreen.minAmount" })}
                  name="min_amount"
                  //onChange={formik.handleChange}
                  onChange={(event) =>
                    handleDataChange(event.target.name, event.target.value)
                  }
                  error={
                    formik.touched.min_amount && Boolean(formik.errors.min_amount)
                  }
                  helperText={
                    formik.touched.min_amount && formik.errors.min_amount
                  }
                />

                <InputField
                  //value={formik.values.max_amount}
                  value={currentTarification.max_amount}
                  type="number"
                  fullWidth
                  label={formatMessage({ id: "sharedScreen.maxAmount" })}
                  placeholder={formatMessage({ id: "sharedScreen.maxAmount" })}
                  name="max_amount"
                  //onChange={formik.handleChange}
                  onChange={(event) =>
                    handleDataChange(event.target.name, event.target.value)
                  }
                  error={
                    formik.touched.max_amount && Boolean(formik.errors.max_amount)
                  }
                  helperText={
                    formik.touched.max_amount && formik.errors.max_amount
                  }
                />

                <InputField
                  //value={formik.values.commission_percentage}
                  value={currentTarification.commission_percentage}
                  type="number"
                  fullWidth
                  label={formatMessage({ id: "sharedScreen.commissionPercentage"})}
                  placeholder={formatMessage({
                    id: "sharedScreen.commissionPercentage",
                  })}
                  name="commission_percentage"
                  //onChange={formik.handleChange}
                  onChange={(event) =>
                    handleDataChange(event.target.name, event.target.value)
                  }
                  error={
                    formik.touched.commission_percentage &&
                    Boolean(formik.errors.description)
                  }
                  helperText={
                    formik.touched.description &&
                    formik.errors.commission_percentage
                  }
                />

                <InputField
                  //value={formik.values.fees}
                  value={currentTarification.fees}
                  variant="outlined"
                  type="number"
                  fullWidth
                  label={formatMessage({ id: "sharedScreen.fixedFees"})}
                  placeholder={formatMessage({ id: "sharedScreen.fixedFees" })}
                  name="fees"
                  //onChange={formik.handleChange}
                  onChange={(event) =>
                    handleDataChange(event.target.name, event.target.value)
                  }
                  error={formik.touched.fees && Boolean(formik.errors.fees)}
                  helperText={formik.touched.description && formik.errors.fees}
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                  className={classes.searchAuto}
                  id="currencies"
                  value={currentTarification.currency}
                  options={currencies}
                  renderInput={param => (<TextField {...param} label={formatMessage({ id: "sharedScreen.currency" })} 
                  variant="outlined" size="small" />)}
                  getOptionLabel= {Option => Option.code}
                  //onChange={formik.handleChange}
                  onChange ={(event, currency) => {currency != null &&  handleDataChange('currency', currency)}}
                />
                {/*<TextField
                  select
                  variant="outlined"
                  size="small"
                  //value={formik.values.currency_id}
                  value={tarification.currency.id}
                  label={formatMessage({ id: "sharedScreen.currency" })}
                  fullWidth
                  name="currency_id"
                  //onChange={formik.handleChange}
                  onChange={(event) =>
                    handleDataChange(event.target.name, event.target.value)
                  }
                  error={
                    formik.touched.currency_id &&
                    Boolean(formik.errors.currency_id)
                  }
                  helperText={
                    formik.touched.currency_id && formik.errors.currency_id
                  }
                >
                  {currenciesObjet.map((currency) => (
                    <MenuItem key={currency.id} value={currency.id}>
                      {currency.code}
                    </MenuItem>
                  ))}
                  </TextField>*/}
              </Grid>
              <br />
              <br />

              <Grid item xs={12} sm={12} lg={12} container direction="row">
                <InputButton
                  disabled={formik.isSubmitting}
                  fullWidth
                  type="submit"
                  variant="contained"
                  color="secondary"
                >
                  <FormattedMessage id="sharedScreen.edit" />
                  {formik.isSubmitting && <CircularProgress size={30} />}
                </InputButton>
              </Grid>
              {succeed && (
                <Grid item xs={12} sm={12} lg={12}>
                  <Alert severity="success">
                    <FormattedMessage id="sharedScreen.icipWithdrawTarificationUpdatedSuccessfully" />
                  </Alert>
                </Grid>
              )}
            </Grid>
          </form>
        </Paper>
      
    </>
  );
};
